import React from "react";
import styled from "styled-components";

const Version = styled.span`
    font-size: 1rem;
    margin-left: 10px;
`;

const AppVersion = ({version}) => (
    <Version>
        v{version}
    </Version>
);

export default AppVersion;